import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Skeleton, _Grid, _Grid2;
var _excluded = ["addMode", "readOnly"];
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, Container, Divider, Grid2, Paper, Skeleton, Stack, TextField, Typography } from '@lumahealthhq/ui-core';
import { FilterFieldContentload, FilterFieldTabLoad } from './components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackFormChecklistTemplate(_ref) {
  var addMode = _ref.addMode,
    readOnly = _ref.readOnly,
    rest = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  return /*#__PURE__*/_jsx(Container, _extends({
    maxWidth: false,
    disableGutters: true
  }, rest, {
    children: /*#__PURE__*/_jsx(Paper, {
      sx: {
        p: 4,
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(Grid2, {
        container: true,
        spacing: 4,
        children: [/*#__PURE__*/_jsxs(Grid2, {
          container: true,
          xs: 12,
          mb: 6,
          children: [/*#__PURE__*/_jsx(Grid2, {
            xs: true,
            children: /*#__PURE__*/_jsx(Stack, {
              gap: 1,
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "h3",
                children: addMode ? intl.formatMessage({
                  id: "gV8AIA",
                  defaultMessage: [{
                    "type": 0,
                    "value": "Add Checklist"
                  }]
                }) : _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
                  variant: "text",
                  width: 300
                }))
              })
            })
          }), !addMode && !readOnly && /*#__PURE__*/_jsx(Grid2, {
            xs: "auto",
            children: /*#__PURE__*/_jsx(Button, {
              variant: "danger",
              disabled: true,
              children: intl.formatMessage({
                id: "emd4z0",
                defaultMessage: [{
                  "type": 0,
                  "value": "Delete form"
                }]
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "h5",
            children: intl.formatMessage({
              id: "GVa3sp",
              defaultMessage: [{
                "type": 0,
                "value": "Checklist Details"
              }]
            })
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(TextField, {
            required: true,
            InputProps: {
              readOnly: readOnly
            },
            disabled: !readOnly,
            fullWidth: true,
            label: intl.formatMessage({
              id: "EBOkPG",
              defaultMessage: [{
                "type": 0,
                "value": "Checklist Name"
              }]
            })
          })
        }), /*#__PURE__*/_jsxs(Grid2, {
          xs: 12,
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            children: intl.formatMessage({
              id: "OJWlat",
              defaultMessage: [{
                "type": 0,
                "value": "Checklist Filters"
              }]
            })
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            children: intl.formatMessage({
              id: "u7Dg6P",
              defaultMessage: [{
                "type": 0,
                "value": "These filters are applied to the checklist:"
              }]
            })
          })]
        }), _Grid || (_Grid = /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsxs(Stack, {
            gap: 3,
            children: [/*#__PURE__*/_jsx(FilterFieldTabLoad, {}), /*#__PURE__*/_jsx(FilterFieldContentload, {})]
          })
        })), _Grid2 || (_Grid2 = /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Divider, {})
        })), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          mb: 2,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: intl.formatMessage({
              id: "isEKx3",
              defaultMessage: [{
                "type": 0,
                "value": "Checklist Items"
              }]
            })
          })
        }), /*#__PURE__*/_jsxs(Grid2, {
          container: true,
          xs: 12,
          spacing: 2,
          children: [/*#__PURE__*/_jsx(Grid2, {
            md: 5,
            lg: 3.5,
            xl: 3,
            children: /*#__PURE__*/_jsx(Skeleton, {
              sx: {
                transform: 'none'
              },
              height: 400,
              width: "100%"
            })
          }), /*#__PURE__*/_jsx(Grid2, {
            xs: 12,
            md: true,
            children: /*#__PURE__*/_jsx(Skeleton, {
              sx: {
                transform: 'none'
              },
              height: 400,
              width: "100%"
            })
          })]
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsxs(Stack, {
            direction: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
            children: [/*#__PURE__*/_jsx(Button, {
              variant: "text",
              disabled: true,
              type: "submit",
              children: intl.formatMessage({
                id: "47FYwb",
                defaultMessage: [{
                  "type": 0,
                  "value": "Cancel"
                }]
              })
            }), !readOnly && /*#__PURE__*/_jsx(Button, {
              variant: "primary",
              type: "submit",
              disabled: true,
              children: addMode ? intl.formatMessage({
                id: "aDpBb2",
                defaultMessage: [{
                  "type": 0,
                  "value": "Create Checklist"
                }]
              }) : intl.formatMessage({
                id: "v3eGtQ",
                defaultMessage: [{
                  "type": 0,
                  "value": "Update Checklist"
                }]
              })
            })]
          })
        })]
      })
    })
  }));
}